import { Component, OnInit, Input } from '@angular/core';
import * as $ from 'jquery';
import {TweenLite, Power1} from "gsap";

@Component({
  selector: 'app-slider-bg',
  templateUrl: './slider-bg.component.html',
  styleUrls: ['./slider-bg.component.scss']
})
export class SliderBgComponent implements OnInit {
  @Input() urls:Array<any>;
  imageurls:Array<any>;

	sliderCount:number=0;
	container:any;
	sliderArray:Array<any>;
	aktuellDiv:any;
	aktuellTween1:any;
	aktuellTween2:any;
	isAniamtionReady:boolean=true;
	setautoStartTimer:any;

	// animationConfi
	animationTime:number=1.5;
	animationDelay:number=5;
	animationEasing:any=Power1.easeInOut;
	startFromFirstImage:boolean=true;
	conta: any;

  constructor() { }

  ngOnInit() {
    this.imageurls = this.urls;
  }

  loadIni(obDom){
	if( this.container == undefined ){
		this.container=$(obDom);
		this.conta=this.container;
		this.iniSlider();
	}
  }

  iniSlider(){
	this.sliderArray=this.container.find(".slider-content");
	// wenn es wieder von vorne starten soll und nicht zurücklaufen darf muss dieses gemacht werden......
	if( this.startFromFirstImage ){
		//_this.container[0].innerHTML=;
		$( this.sliderArray[0].outerHTML ).insertAfter( this.sliderArray[ (this.sliderArray.length-1) ] );
		this.sliderArray=this.container.find(".slider-content");
	}
	
	for(var d=0;d<this.sliderArray.length;d++){
		$(this.sliderArray[d]).css( "left", (100*d)+"%" );
	}
	
	
	var attrID=this.container.attr("id");
	//make points
	//addElement( { id:attrID+"-sliderIndexContainer", class:"sliderIndexContainer" }, document.getElementById( attrID ) , "div" );
	
	//addElement( { id:attrID+"-pfeilRechts", class:"sliderPfeil rechts", innerHTML:'<img src="/images/pfeil-rechts.svg" class="clearfix img-center" />' }, document.getElementById( attrID ) , "div" );
	
	//addElement( { id:attrID+"-pfeilLinks", class:"sliderPfeil links", innerHTML:'<img src="/images/pfeil-links.svg" class="clearfix img-center" />' }, document.getElementById( attrID ) , "div" );
	
	this.aktuellDiv=this.sliderArray[0];
	

	// Pfeile links und Rechts sind nicht richtig implementiert
	/*
	$( "#"+attrID+"-pfeilRechts" ).click(function() {
		  this.buttonClickRechtsLinks(this);
		});
	$( "#"+attrID+"-pfeilLinks" ).click(function() {
		this.buttonClickRechtsLinks(this);
	});
	*/

	//Pointer unter dem Slider // noch nicht richtig eingebaut!!
	/*
	for(var d=0;d<this.sliderArray.length;d++){
		addElement( { id: attrID+"-"+"sliderIndex"+d, class:"sliderIndex pointer" }, document.getElementById( attrID+"-sliderIndexContainer" ) );	
		var point=$( "#"+attrID+"-"+"sliderIndex"+d )
		point.attr("data-point", d );
		point.click(function() {
		  this.buttonClick(this);
		});
	}
	addClass( document.getElementById(  attrID+"-"+"sliderIndex0" ), "aktive" );
	*/

	if(this.sliderArray.length>1){
		this.startSlider();
	}

  }


  	animation( stepp, th ){
		this.isAniamtionReady=false;
		if( stepp>=0  ){
			stepp=Math.abs(stepp);
			if( !this.startFromFirstImage ){
				this.aktuellTween1=TweenLite.to( this.sliderArray , this.animationTime , {css:{left:"+="+(stepp*100)+"%"}, ease:this.animationEasing, onComplete:()=>{this.isAniamtionReady=true;this.startSlider();} } ); 
			}
			else{
				this.aktuellTween1=TweenLite.to( this.sliderArray , 0 , {css:{left:"+="+(stepp*100)+"%"}, ease:this.animationEasing, onComplete:()=>{this.isAniamtionReady=true; this.startSlider("withoutTime");} } ); 
			}
		}else{
			stepp=Math.abs(stepp);
			this.aktuellTween1=TweenLite.to( this.sliderArray , this.animationTime , {css:{left:"-="+(stepp*100)+"%"}, ease:this.animationEasing, onComplete:()=>{this.isAniamtionReady=true;this.startSlider();} } ); 
		}
		for(var d=0;d<this.sliderArray.length;d++){
			$( document.getElementById(  this.container.attr("id")+"-"+"sliderIndex"+d )).removeClass( "aktive" );
		}
		$(th).addClass( "aktive" );
		
	}

	startSlider( parm:any=undefined ){
		if(parm==undefined){
			this.setautoStartTimer = setTimeout( ()=>{
				var d=((this.sliderArray.length-1-this.sliderCount)>0)?-1:this.sliderArray.length-1;
				this.sliderCount=(this.sliderCount+1<this.sliderArray.length)?this.sliderCount+1:0;
				this.animation( d , document.getElementById(  this.container.attr("id")+"-"+"sliderIndex"+(this.sliderCount) ) );
			} , this.animationDelay*1000 );
		}else if(parm=="withoutTime"){
			var d=((this.sliderArray.length-1-this.sliderCount)>0)?-1:this.sliderArray.length-1;
			this.sliderCount=(this.sliderCount+1<this.sliderArray.length)?this.sliderCount+1:0;

			this.animation( d , document.getElementById(  this.container.attr("id")+"-"+"sliderIndex"+(this.sliderCount) ) );
		}
	}

}

/*

		_this.buttonClickRechtsLinks=function(th){
			clearTimeout( _this.setautoStartTimer );
			
			if(_this.isAniamtionReady==true){
				if( _this.aktuellTween1 != undefined ){
					_this.aktuellTween1.kill();
				}

				if( hasClass( th , "links" ) == false ){
					var divinView=_this.aktuellDiv;

					var d=((_this.sliderArray.length-1-_this.sliderCount)>0)?-1:_this.sliderArray.length-1;
					_this.sliderCount=(_this.sliderCount+1<_this.sliderArray.length)?_this.sliderCount+1:0;

					animation( d , document.getElementById(  _this.container.attr("id")+"-"+"sliderIndex"+(_this.sliderCount) ) );
				}else{
					var divinView=_this.aktuellDiv;

					var d=((_this.sliderCount)>0)?1:(_this.sliderArray.length-1)*-1;
					_this.sliderCount=(_this.sliderCount-1>=0)?_this.sliderCount-1:_this.sliderArray.length-1;
					
					animation( d , document.getElementById(  _this.container.attr("id")+"-"+"sliderIndex"+(_this.sliderCount) ) );
				}
			}
		}
		
		_this.buttonClick=function(th){
			clearTimeout( _this.setautoStartTimer );
			if(_this.isAniamtionReady==true){
				var point=$(th);
				if( _this.aktuellTween1 != undefined ){
					_this.aktuellTween1.kill();
				}

				var stepp=_this.sliderCount-parseInt( point.attr("data-point") );
				_this.sliderCount=parseInt( point.attr("data-point") );

				animation( stepp, th );
			}
		};
	
		
		headerSlider();
	};

}

*/